import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IOnChangesObject, IScope} from "angular";
import {l} from "../../../types/typescriptdefinisjoner_lederplan";
import {changesInneholder} from "../../stoettefunk/angularHjelpemetoder";
import _ from "lodash";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('MoeteDeltakerStatusKomponent');

/**
 * Viser innkallingsstatus på møte.
 *
 * <wk-moete-deltakere-status deltakere="$ctrl.etmoete.deltakere" ></wk-moete-deltakere-status>
 */
export class MoeteDeltakereStatusKomponent implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkMoeteDeltakereStatus', {
                bindings: {
                    deltakere:'<'
                },
                controller: MoeteDeltakereStatusKomponent.forInjisering(),
                template: require('./moeteDeltakereStatus.html'),
                transclude: true
            })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            MoeteDeltakereStatusKomponent
        ]
    }

    constructor(private $scope: IScope) {}

    deltakere: l.MøtedeltakerModell[];

    antallDeltakere:number;
    antallIkkeSendt:number;
    antallGodtatt:number;
    antallAvslaatt:number;
    antallInvitasjonSendtEllerGodtattEllerAvslaatt:number;

    // {{antallDeltakere}} deltaker - Innkalling ikke sendt
    visInnkallingIkkeSendtTilNoen:boolean;

    // {{antallDeltakere}} deltaker - {{antallinvitasjonsendtellergodtattavslaatt}} innkalt
    visInnkallingIkkeSendtTilAlle:boolean;

    // {{antallDeltakere}} deltaker - {{antallgodtatt}} godtatt
    visInnkallingSendt:boolean;

    // {{antallDeltakere}} deltaker - {{antallavslaatt}} avslått
    visInnkallingSendtBareAvslaatte:boolean;

    private watchDeregistrering:()=>void;

    // kunne ikke kun ha møte som input, da ble ikke endringer fanget opp. Ved å bytte til møte.deltaker funker dette.
    $onChanges(changes: IOnChangesObject) {
        if (changesInneholder(changes, 'deltakere')){
            this.leggTilWatch();
            this.initDeltakere();
        }
    }

    private leggTilWatch() {
        if (this.watchDeregistrering) this.watchDeregistrering(); //siden leggTilWatch kan bli kalt multiple ganger - slik at vi ikke reg duplikate watchere
        if (this.deltakere == null) return;

        //reagerer på endringer i deltaker.status ved å konkatere disse til streng og la angular reagere på endringer i denne strengen
        //dette fremfor å håndtere egne watchere per deltaker..
        this.watchDeregistrering = this.$scope.$watch(
            () => this.deltakere.map(deltaker => deltaker.status).join(','),
            () => this.initDeltakere());
    }

    private initDeltakere() {
        if (this.deltakere == null) return;

        this.antallDeltakere = this.deltakere.length;
        this.antallIkkeSendt = _(this.deltakere).filter({status: l.Deltakerstatus.innkalling_ikke_sendt}).value().length;
        this.antallGodtatt = _(this.deltakere).filter({status: l.Deltakerstatus.akseptert}).value().length;
        this.antallAvslaatt = _(this.deltakere).filter({status: l.Deltakerstatus.avslaatt}).value().length;
        const antallSendt = _(this.deltakere).filter({status: l.Deltakerstatus.innkalling_sendt}).value().length;
        this.antallInvitasjonSendtEllerGodtattEllerAvslaatt = antallSendt + this.antallGodtatt + this.antallAvslaatt;
        this.visInnkallingIkkeSendtTilNoen = this.antallDeltakere === this.antallIkkeSendt;
        this.visInnkallingIkkeSendtTilAlle = !this.visInnkallingIkkeSendtTilNoen && this.antallIkkeSendt > 0;
        this.visInnkallingSendtBareAvslaatte =
          !this.visInnkallingIkkeSendtTilNoen
          && !this.visInnkallingIkkeSendtTilAlle
          && this.antallGodtatt === 0
          && this.antallAvslaatt > 0;

        // alle har fått innkalling og ( (0 har godtatt og 0 har avslått) eller (mer enn 1 har godtatt))
        this.visInnkallingSendt = !this.visInnkallingIkkeSendtTilNoen && !this.visInnkallingIkkeSendtTilAlle && !this.visInnkallingSendtBareAvslaatte;
    }
}
